
import React, { useState,useEffect} from "react";

const documents = [
{
    id: 8,
    category: "Data Management Report",
    title: "Career Compass Assessment Findings",
    description: "Pre- and post-assessment findings for Career Compass training sessions of 2024.",
    image: "/assets/career.jpg",
    link: "/PDF/ProgramAssessment/CareerCompassPrePostAssessmentFindings.pdf",
  },
  {
    id: 11,
    category: "Data Management Report",
    title: "DAAP Dropout Survey",
    description: "Analysis of dropout reasons and trends in the DAAP program on 2024 trainees.",
    image: "/assets/daap3.jpg",
    link: "/PDF/ProgramAssessment/DAAPDropoutSurvey.pdf",
  },
   {
    id: 21,
    category: "Data Management Report",
    title: "Internship Program FGD Report",
    description: "Focus group discussion findings from participants in regional internship programs.",
    image: "/assets/p18.jpg",
    link: "/PDF/ProgramAssessment/FGDofInternshipprogram.pdf",
  },

  {
    id: 4,
    category: "Data Management Report",
    title: "2023 DAAP Graduate Status Survey",
    description: "A brief survey results analyzing the status of DAAP graduates of 2023.",
    image: "/assets/p21.jpg",
    link: "/PDF/ProgramAssessment/2023DAAPGraduatesStatusSurvey.pdf",
  },
  
  {
    id: 5,
    category: "Data Management Report",
    title: "2023 Focus Group Discussion Report",
    description: "Insights gathered from focus group discussions held during program assessments in 2023.",
    image: "/assets/p18.jpg",
    link: "/PDF/ProgramAssessment/2023FocusGroupDiscussionReported.pdf",
  },
  {
    id: 6,
    category: "Data Management Report",
    title: "2023 Website Assessment Report",
    description: "Evaluation of Dereja’s website performance and user experience in 2023.",
    image: "/assets/website.png",
    link: "/PDF/ProgramAssessment/2023WebsiteAssessmentFindingReport.pdf",
  },
  {
    id: 7,
    category: "Data Management Report",
    title: "2023 Beneficiary Satisfaction Survey",
    description: "Comprehensive survey evaluating beneficiaries' satisfaction with Dereja's programs in 2023.",
    image: "/assets/bssc.png",
    link: "/PDF/ProgramAssessment/BeneficiarySatisfactionSurvey2023.pdf",
  },
  {
    id: 12,
    category: "Data Management Report",
    title: "DAAP Post-Training FGD",
    description: "Summary of post-training focus group discussions for DAAP participants.",
    image: "/assets/p19.jpg",
    link: "/PDF/ProgramAssessment/DAAPposttrainingFocusGroupDisccusion.pdf",
  },
  {
    id: 16,
    category: "Data Management Report",
    title: "Website & Social Media Monitoring Report",
    description: "Monitoring report covering website and social media analytics.",
    image: "/assets/internaldatamgt.png",
    link: "/PDF/ProgramAssessment/DerejaWebsiteSocialMediaMonitoringReport.pdf",
  },
  {
    id: 17,
    category: "Data Management Report",
    title: "Digital Platform Needs Assessment",
    description: "Findings on digital platform requirements and improvement areas.",
    image: "/assets/socialmedia.png",
    link: "/PDF/ProgramAssessment/DigitalPlatformNeedAssessmentFindings.pdf",
  },
  {
    id: 18,
    category: "Data Management Report",
    title: "DLS Assessment Finding Report",
    description: "Overview of Dereja Literacy Skill(DLS) program assessment done on both beginner and intermediate level trainees and trainess finding report.",
    image: "/assets/dls.jpg",
    link: "/PDF/ProgramAssessment/DLSReport.pdf",
  },
  {
    id: 19,
    category: "Data Management Report",
    title: "DLS Training & Development Report",
    description: "Detailed report on the development and implementation of DLS training modules.",
    image: "/assets/dlstot.png",
    link: "/PDF/ProgramAssessment/DLSTrainingDevelopmentandImplementationReportV2.pdf",
  },
  {
    id: 24,
    category: "Data Management Report",
    title: "University Social Media Tracking Report – 2023",
    description: "Report on universities' social media engagement tracking in 2023.",
    image: "/assets/socialmediatracking.png",
    link: "/PDF/ProgramAssessment/UniversitySocialMediaTracking2023.pdf",
  },
  
{
    id: 14,
    category: "Data Management Report",
    title: "DBU Baseline Assessment",
    description: "Baseline assessment report from DBU on program impact and readiness.",
    image: "/assets/Screenshot20250617143022.jpg",
    link: "/PDF/ProgramAssessment/DBUBaselineAssessmentReport.pdf",
  },
  {
    id: 1,
    category: "Data Management Report",
    title: "2022 Beneficiary Satisfaction Survey",
    description: "Assessment of beneficiaries' satisfaction with Dereja services in 2022.",
    image: "/assets/bss.jpg",
    link: "/PDF/ProgramAssessment/2022DerejaBeneficiarySatisfactionSurvey.pdf",
  },
  {
    id: 2,
    category: "Data Management Report",
    title: "2022 Employer Pool Engagement Assessment",
    description: "Analysis of employer engagement levels and partnership outcomes in 2022.",
    image: "/assets/employerpool.jpg",
    link: "/PDF/ProgramAssessment/2022EmployerPoolEngagementAssessment.pdf",
  },
    {
    id: 10,
    category: "Data Management Report",
    title: "DAAP 2022 Cohort 1 Assessment",
    description: "Evaluation of the first cohort in the 2022 DAAP program.",
    image: "/assets/daap1.jpg",
    link: "/PDF/ProgramAssessment/DAAP2022cohort1assessment.pdf",
  },
   {
    id: 23,
    category: "Data Management Report",
    title: "Supervision Report – Dire Dawa & Haramaya",
    description: "A supervision report conducted in 2022 at Dire Dawa and Haramaya Universities.",
    image: "/assets/supervision.png",
    link: "/PDF/ProgramAssessment/SupervisionReportDD&HARFinal.pdf",
  },
  {
    id: 15,
    category: "Data Management Report",
    title: "2022 Job Fair Findings",
    description: "Key insights and metrics from Dereja’s 2022 Job Fair.",
    image: "/assets/jobfair.jpg",
    link: "/PDF/ProgramAssessment/Dereja2022JobFairFindings.pdf",
  },
  {
    id: 3,
    category: "Data Management Report",
    title: "2023 Employability Skills Training Assessment",
    description: "Findings from the assessment of employability skills training outcomes in 2023.",
    image: "/assets/esjr5.jpg",
    link: "/PDF/ProgramAssessment/2023EmployabilitySkillsTrainingAssessmentFinding.pdf",
  },
    {
    id: 20,
    category: "Data Management Report",
    title: "Employer Assessment Report – 2022 Job Fair",
    description: "Findings from the evaluation of employer during the 2022 Job Fair.",
    image: "/assets/employer.png",
    link: "/PDF/ProgramAssessment/EMPLOYERSAssessmentREPORT2022(Job fair).pdf",
  },
  
    {
    id: 9,
    category: "Data Management Report",
    title: "Hiring Needs Assessment Survey 2020",
    description: "Survey on campanies' hiring needs, talent demand and trends.",
    image: "/assets/companies.jpg",
    link: "/PDF/ProgramAssessment/CompaniesHiringNeedAssessmentSurveyReport.pdf",
  },
   

];


export default function KnowledgeLibrary() {
  useEffect(() => {
        window.scrollTo(0, 0); 
      }, []);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const itemsPerPage = 6;

  
  const filteredDocs = documents.filter((doc) =>
    doc.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    doc.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredDocs.length / itemsPerPage);
  const startIndex = page * itemsPerPage;
  const paginatedDocs = filteredDocs.slice(startIndex, startIndex + itemsPerPage);

  const handleNext = () => {
    if (page < totalPages - 1) setPage(page + 1);
  };

  const handlePrev = () => {
    if (page > 0) setPage(page - 1);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setPage(0); 
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-3xl font-bold text-orange mb-6 text-center">
        Knowledge Management Library
      </h1>

      <div className="max-w-2xl mx-auto mb-8">
        <input
          type="text"
          placeholder="Search documents..."
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400"
          onChange={handleSearch}
          value={searchTerm}
        />
        <p className="text-sm text-gray-600 mt-2">
          {filteredDocs.length > 0
            ? `Showing ${startIndex + 1}-${Math.min(
                startIndex + paginatedDocs.length,
                filteredDocs.length
              )} of ${filteredDocs.length} documents`
            : `No results found for "${searchTerm}"`}
        </p>
      </div>

      {filteredDocs.length > 0 ? (
        <>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 mb-8">
            {paginatedDocs.map((doc) => (
              <div
                key={doc.id}
                className="bg-white rounded-xl shadow hover:shadow-md p-4"
              >
                <img
                  src={doc.image}
                  alt={doc.title}
                  className="h-40 w-full object-cover rounded-md mb-4"
                />
                <h3 className="text-lg font-semibold text-gray-800">
                  {doc.title}
                </h3>
                <p className="text-sm text-gray-600">{doc.description}</p>
                <a
                  href={doc.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-3 inline-block text-orange-600 hover:underline text-sm"
                >
                  View Document
                </a>
              </div>
            ))}
          </div>

          <div className="flex justify-center gap-4">
            <button
              onClick={handlePrev}
              disabled={page === 0}
              className={`px-4 py-2 rounded-md font-semibold ${
                page === 0
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-orange text-white hover:bg-orange-600"
              }`}
            >
              Previous
            </button>
            <button
              onClick={handleNext}
              disabled={page >= totalPages - 1}
              className={`px-4 py-2 rounded-md font-semibold ${
                page >= totalPages - 1
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-orange text-white hover:bg-orange-600"
              }`}
            >
              Next
            </button>
          </div>
        </>
      ) : (
        <div className="text-center text-gray-500 text-lg mt-20">
          📄 No documents match your search.
        </div>
      )}
    </div>
  );
}